import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import {
  apiRequest,
  showLoading,
  saveTeamUUID,
  savePlayerCode,
  saveSessionUUID,
} from "../../utils";
import { TEAM_COLORS } from "../../constants";
import { CodeInput } from "../../components/CodeInput/code-input";

import ss from "./join.module.css";

export const JoinPage = () => {
  const team_uuid = new URLSearchParams(window.location.search).get("tid");
  const navigate = useNavigate();
  const [teamInfo, setTeamInfo] = useState(null);
  const [confirmBtnDisabled, setConfirmBtnDisabled] = useState(true);
  const codeInput1Ref = useRef("");
  const codeInput2Ref = useRef("");
  const [hint, setHint] = useState("");

  const getTeamInfo = async () => {
    const loading = showLoading("加载中");
    apiRequest("/get_team_info", "GET", {
      team_uuid,
    })
      .then((res) => {
        if (res.code === 0) setTeamInfo(res.data);
        else setHint(res.msg);
      })
      .finally(() => loading.hide());
  };

  const checkCodeInputFinished = () => {
    console.log(codeInput1Ref.current, codeInput2Ref.current);
    const code1 = codeInput1Ref.current;
    const code2 = codeInput2Ref.current;
    return code1.length === 4 && code2.length === 4;
  };

  const onConfirmClick = () => {
    if (!checkCodeInputFinished()) return;
    if (codeInput1Ref.current !== codeInput2Ref.current) {
      setHint("两次输入的登录码不一致");
      return;
    }
    setHint("");
    const loading = showLoading("加载中");
    apiRequest("/player_join_team", "POST", {
      team_uuid,
      code: codeInput1Ref.current,
    })
      .then((res) => {
        if (res.code === 0) {
          saveSessionUUID(res.session_uuid);
          saveTeamUUID(team_uuid);
          savePlayerCode(codeInput1Ref.current);
          if (res.session_status === 0) {
            navigate("/guide", { replace: true });
          } else navigate("/game", { replace: true });
        } else setHint(res.msg);
      })
      .finally(() => loading.hide());
  };

  useEffect(() => {
    getTeamInfo();
  }, []);

  if (!teamInfo) return null;

  return (
    <div className={ss.page}>
      <div className={ss.content}>
        <img
          className={ss.avatar}
          src={require(`../../imgs/team/color${teamInfo.color}.png`)}
          alt=""
        />
        <div className={ss.name} style={{ color: TEAM_COLORS[teamInfo.color] }}>
          【{teamInfo.name}】
        </div>
        <div className={ss.inputGroup}>
          <div className={ss.label}>请设置登录码</div>
          <CodeInput
            name="code1"
            onChange={(code) => {
              codeInput1Ref.current = code;
              setConfirmBtnDisabled(!checkCodeInputFinished());
            }}
          />
          <div className={ss.label2}>请再输入一次登录码</div>
          <CodeInput
            name="code2"
            onChange={(code) => {
              codeInput2Ref.current = code;
              setConfirmBtnDisabled(!checkCodeInputFinished());
            }}
          />
        </div>
        <div className={ss.hint}>{hint}</div>
      </div>
      <div
        className={classNames(ss.confirmBtn, confirmBtnDisabled && ss.disabled)}
        onClick={onConfirmClick}
      >
        确认
      </div>
    </div>
  );
};
